import type { FC } from 'react';

const faqItems = [
  {
    question: '什么是ASMR？',
    answer: 'ASMR（Autonomous Sensory Meridian Response）即"自主感觉经络反应"，是一种由特定听觉或视觉刺激引发的愉悦感和放松感。常见的感觉包括头皮酥麻、脊椎发凉等，被爱好者们称为"颅内高潮"或"大脑按摩"。',
  },
  {
    question: 'ASMR基佬中心是免费的吗？',
    answer: '是的，ASMR基佬中心的所有内容目前都是免费开放给所有用户访问的。我们致力于让更多人能够轻松享受到优质的ASMR内容。',
  },
  {
    question: '如何开始我的ASMR体验？',
    answer: '我们建议新手从以下几点开始：1）准备一副舒适的耳机；2）选择安静的环境；3）从"耳语陪伴"或"助眠放松"分类开始尝试；4）保持耐心，不是每个人都能立刻感受到ASMR；5）浏览不同分类，找到最适合你的声音类型。',
  },
  {
    question: 'ASMR对失眠真的有效吗？',
    answer: '研究表明，ASMR对于改善睡眠质量有显著效果。通过降低心率、减少压力激素的分泌，ASMR能够帮助大脑从活跃状态过渡到放松状态。在我们的用户调查中，超过78%的失眠用户表示睡眠质量得到了明显改善。',
  },
  {
    question: '平台上目前有哪些ASMR分类？',
    answer: '我们目前涵盖了六大主流ASMR分类：助眠放松、耳语陪伴、触发音效、角色扮演、美食咀嚼和环境白噪音。每个分类下都有大量精心挑选的优质内容。',
  },
  {
    question: '如何联系ASMR基佬中心？',
    answer: '您可以通过发送邮件至 hello@jybmfiu.cn 或添加微信 ASMRGeekCenter 联系我们。工作时间为周一至周五 09:00至18:00。',
  },
];

const FAQSection: FC = () => {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question' as const,
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer' as const,
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">关于ASMR和平台的常见疑问，这里都有解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <details key={index} className="group rounded-lg border border-background-200/60 bg-background-100 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;